"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createChangePropertyActionTypes = _interopRequireDefault(require("./actions/createChangePropertyActionTypes"));

var _createResetChangesForStagedObjectActionType = _interopRequireDefault(require("./actions/createResetChangesForStagedObjectActionType"));

var _createAddToOrderedMapAction = _interopRequireDefault(require("./actions/createAddToOrderedMapAction"));

var _createRemoveFromOrderedMapAction = _interopRequireDefault(require("./actions/createRemoveFromOrderedMapAction"));

var _createReorderOrderedMapAction = _interopRequireDefault(require("./actions/createReorderOrderedMapAction"));

var _createResetChangesForStagedObjectAction = _interopRequireDefault(require("./actions/createResetChangesForStagedObjectAction"));

var _createStagedObjectReducer = _interopRequireDefault(require("./reducers/createStagedObjectReducer"));

var _createStagedObjectSelectors = _interopRequireDefault(require("./selectors/createStagedObjectSelectors"));

var _createStageForEditAction = _interopRequireDefault(require("./actions/createStageForEditAction"));

var _createStageForEditActionType = _interopRequireDefault(require("./actions/createStageForEditActionType"));

var _createChangePropertyAction = _interopRequireDefault(require("./actions/createChangePropertyAction"));

var _createChangeNestedPropertyAction = _interopRequireDefault(require("./actions/createChangeNestedPropertyAction"));

var _createResetAllChangesEpic = _interopRequireDefault(require("./epics/createResetAllChangesEpic"));

var _createResetChangesToStagedObjectEpic = _interopRequireDefault(require("./epics/createResetChangesToStagedObjectEpic"));

var _default = function _default(_ref) {
  var domainSelector = _ref.domainSelector,
      stagedSelector = _ref.stagedSelector,
      properties = _ref.properties,
      objectType = _ref.objectType,
      requestSuccessActionType = _ref.requestSuccessActionType,
      requestSuccessDataSelector = _ref.requestSuccessDataSelector,
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === void 0 ? "" : _ref$namespace,
      _ref$actionHandlers = _ref.actionHandlers,
      actionHandlers = _ref$actionHandlers === void 0 ? {} : _ref$actionHandlers;
  var actionTypes = (0, _createChangePropertyActionTypes.default)({
    namespace: namespace,
    objectType: objectType,
    properties: properties
  });
  var reducer = (0, _createStagedObjectReducer.default)({
    properties: properties,
    actionTypes: actionTypes,
    objectType: objectType,
    requestSuccessActionType: requestSuccessActionType,
    requestSuccessDataSelector: requestSuccessDataSelector,
    namespace: namespace,
    actionHandlers: actionHandlers
  });
  var selectors = (0, _createStagedObjectSelectors.default)({
    stagedSelector: stagedSelector,
    domainSelector: domainSelector,
    properties: properties
  });
  var stageForEditActionType = (0, _createStageForEditActionType.default)({
    namespace: namespace,
    objectType: objectType
  });
  var stageForEdit = (0, _createStageForEditAction.default)({
    namespace: namespace,
    objectType: objectType
  });
  var anyChanges = selectors.anyChanges;
  var numberOfChanges = selectors.numberOfChanges;
  var isChanged = selectors.isChanged;

  var changeProperty = function changeProperty(property) {
    return (0, _createChangePropertyAction.default)({
      actionTypes: actionTypes,
      property: property
    });
  };

  var changeNestedProperty = function changeNestedProperty(propertyPath) {
    return (0, _createChangeNestedPropertyAction.default)({
      actionTypes: actionTypes,
      propertyPath: propertyPath
    });
  };

  var getChangePropertyActionType = function getChangePropertyActionType(property) {
    return actionTypes[property];
  };

  var getDomainProperty = function getDomainProperty(property) {
    return selectors.getDomainProperty(property);
  };

  var getReducer = function getReducer() {
    return reducer;
  };

  var getDomainObject = function getDomainObject(state) {
    return domainSelector(state);
  };

  var getStagedObject = function getStagedObject(state) {
    return stagedSelector(state);
  };

  var getStagedProperty = function getStagedProperty(property) {
    return selectors.getStagedProperty(property);
  };

  var getStagedNestedProperty = function getStagedNestedProperty(propertyPath) {
    return selectors.getStagedNestedProperty(propertyPath);
  };

  var getStagedOrderedMapPropertyAsArray = function getStagedOrderedMapPropertyAsArray(property) {
    return selectors.getStagedOrderedMapPropertyAsArray(property);
  };

  var addToStagedOrderedSet = function addToStagedOrderedSet(property) {
    return (0, _createAddToOrderedMapAction.default)({
      actionTypes: actionTypes,
      property: property
    });
  };

  var removeFromStagedOrderedSet = function removeFromStagedOrderedSet(property) {
    return (0, _createRemoveFromOrderedMapAction.default)({
      actionTypes: actionTypes,
      property: property
    });
  };

  var reorderStagedOrderedSet = function reorderStagedOrderedSet(property) {
    return (0, _createReorderOrderedMapAction.default)({
      actionTypes: actionTypes,
      property: property
    });
  };

  var getStageForEditActionType = function getStageForEditActionType() {
    return stageForEditActionType;
  };

  var getResetAllStagedChangesEpic = function getResetAllStagedChangesEpic() {
    return (0, _createResetAllChangesEpic.default)({
      domainSelector: domainSelector,
      stageForEdit: stageForEdit
    });
  };

  var getResetChangesToStagedObjectEpic = function getResetChangesToStagedObjectEpic() {
    return (0, _createResetChangesToStagedObjectEpic.default)({
      domainSelector: domainSelector,
      stageForEdit: stageForEdit,
      resetChangesToStagedObjectActionType: (0, _createResetChangesForStagedObjectActionType.default)({
        namespace: namespace,
        objectType: objectType
      })
    });
  };

  var resetChangesToStagedObject = (0, _createResetChangesForStagedObjectAction.default)({
    namespace: namespace,
    objectType: objectType
  });
  return {
    numberOfChanges: numberOfChanges,
    anyChanges: anyChanges,
    isChanged: isChanged,
    changeProperty: changeProperty,
    changeNestedProperty: changeNestedProperty,
    addToStagedOrderedSet: addToStagedOrderedSet,
    removeFromStagedOrderedSet: removeFromStagedOrderedSet,
    reorderStagedOrderedSet: reorderStagedOrderedSet,
    getChangePropertyActionType: getChangePropertyActionType,
    getDomainObject: getDomainObject,
    getDomainProperty: getDomainProperty,
    getReducer: getReducer,
    getResetAllStagedChangesEpic: getResetAllStagedChangesEpic,
    getResetChangesToStagedObjectEpic: getResetChangesToStagedObjectEpic,
    getStagedObject: getStagedObject,
    getStagedProperty: getStagedProperty,
    getStagedNestedProperty: getStagedNestedProperty,
    getStagedOrderedMapPropertyAsArray: getStagedOrderedMapPropertyAsArray,
    getStageForEditActionType: getStageForEditActionType,
    resetChangesToStagedObject: resetChangesToStagedObject,
    stageForEdit: stageForEdit
  };
};

exports.default = _default;
module.exports = exports.default;